import {HierarchySnapshot} from 'modules/hierarchy/core/models';
import {useMemo} from 'react';
import {ChangesCollector} from 'shared/modules/reports/utils/changes-collector';

export function useFakeChangesCollector(hierarchy: HierarchySnapshot) {
	return useMemo(() => new ChangesCollector({id: 0, type: 0}, hierarchy), []);
}